import { ListPaginationMeta } from "utils/helpers/pagination";

export interface UnderCarriageRow {
  subChassisId: string;
  subChassisName: string;
  subChassisHeight?: number;
}

export interface UnderCarriageForm {
  code: string;
  description: string;
  height: string;
}

export enum FieldType {
  String = "string",
  Number = "number",
}

export const FieldValues: Record<keyof UnderCarriageForm, FieldType> = {
  code: FieldType.String,
  description: FieldType.String,
  height: FieldType.Number,
};

export type UnderCarriageListMeta = ListPaginationMeta;

export interface UnderCarriageListResponse {
  statusCode: number;
  message: string | Record<string, string>;
  data: UnderCarriageRow[];
  meta?: UnderCarriageListMeta;
}

export interface UnderCarriageUpdate {
  id: string;
  subChassisName: string;
  subChassisHeight: number;
}

export interface UnderCarriageDetailResponse {
  statusCode: number;
  message: string | Record<string, string>;
  data: UnderCarriageRow;
}

export interface UnderCarriageState {
  loading: boolean;
  saving: boolean;
  list: UnderCarriageRow[];
  page: number;
  perPage: number;
  meta: UnderCarriageListMeta;
  error: string | null;
  isAddModalOpen: boolean;
  form: UnderCarriageForm;
  detail: UnderCarriageRow | null;
  detailLoading: boolean;
  detailError: string | null;
}
